/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/generate-component-factory.js to modify the generation of this file.
import React from 'react';
import Loadable from 'react-loadable';
const CommonAnimationsRiseAndFade = Loadable({
  loader: () => import(/* webpackChunkName: "RiseAndFade" */ '../components/Common/Animations/RiseAndFade'),
  loading: () => <div></div>,
  modules: ['Common/Animations/RiseAndFade'],
  });
const CommonAnimationsSearchSkeleton = Loadable({
  loader: () => import(/* webpackChunkName: "SearchSkeleton" */ '../components/Common/Animations/SearchSkeleton'),
  loading: () => <div></div>,
  modules: ['Common/Animations/SearchSkeleton'],
  });
const CommonHelperGetAncestorElement = Loadable({
  loader: () => import(/* webpackChunkName: "GetAncestorElement" */ '../components/Common/Helper/GetAncestorElement'),
  loading: () => <div></div>,
  modules: ['Common/Helper/GetAncestorElement'],
  });
const CommonTilesFeaturedLifestyle = Loadable({
  loader: () => import(/* webpackChunkName: "FeaturedLifestyle" */ '../components/Common/Tiles/FeaturedLifestyle'),
  loading: () => <div></div>,
  modules: ['Common/Tiles/FeaturedLifestyle'],
  });
const CommonTilesFeaturedRecipe = Loadable({
  loader: () => import(/* webpackChunkName: "FeaturedRecipe" */ '../components/Common/Tiles/FeaturedRecipe'),
  loading: () => <div></div>,
  modules: ['Common/Tiles/FeaturedRecipe'],
  });
const FeatureBlogBlogDetails = Loadable({
  loader: () => import(/* webpackChunkName: "BlogDetails" */ '../components/Feature/Blog/BlogDetails'),
  loading: () => <div></div>,
  modules: ['Feature/Blog/BlogDetails'],
  });
const FeatureCampaignCampaignDetails = Loadable({
  loader: () => import(/* webpackChunkName: "CampaignDetails" */ '../components/Feature/Campaign/CampaignDetails'),
  loading: () => <div></div>,
  modules: ['Feature/Campaign/CampaignDetails'],
  });
const FeatureCampaignCampaignTitle = Loadable({
  loader: () => import(/* webpackChunkName: "CampaignTitle" */ '../components/Feature/Campaign/CampaignTitle'),
  loading: () => <div></div>,
  modules: ['Feature/Campaign/CampaignTitle'],
  });
const FeatureCategoryRelatedSubcategory = Loadable({
  loader: () => import(/* webpackChunkName: "RelatedSubcategory" */ '../components/Feature/Category/RelatedSubcategory'),
  loading: () => <div></div>,
  modules: ['Feature/Category/RelatedSubcategory'],
  });
const FeatureCentreServicesCentreServicesHighlight = Loadable({
  loader: () => import(/* webpackChunkName: "CentreServicesHighlight" */ '../components/Feature/CentreServices/CentreServicesHighlight'),
  loading: () => <div></div>,
  modules: ['Feature/CentreServices/CentreServicesHighlight'],
  });
const FeatureCentreServicesCentreServicesListInlineImage = Loadable({
  loader: () => import(/* webpackChunkName: "CentreServicesListInlineImage" */ '../components/Feature/CentreServices/CentreServicesListInlineImage'),
  loading: () => <div></div>,
  modules: ['Feature/CentreServices/CentreServicesListInlineImage'],
  });
const FeatureCentreServicesCentreServicesListLeftImage = Loadable({
  loader: () => import(/* webpackChunkName: "CentreServicesListLeftImage" */ '../components/Feature/CentreServices/CentreServicesListLeftImage'),
  loading: () => <div></div>,
  modules: ['Feature/CentreServices/CentreServicesListLeftImage'],
  });
const FeatureCentreServicesFeaturedServicesHighlight = Loadable({
  loader: () => import(/* webpackChunkName: "FeaturedServicesHighlight" */ '../components/Feature/CentreServices/FeaturedServicesHighlight'),
  loading: () => <div></div>,
  modules: ['Feature/CentreServices/FeaturedServicesHighlight'],
  });
const FeatureCinemaNowShowing = Loadable({
  loader: () => import(/* webpackChunkName: "NowShowing" */ '../components/Feature/Cinema/NowShowing'),
  loading: () => <div></div>,
  modules: ['Feature/Cinema/NowShowing'],
  });
const FeatureConsumerArticleArticleDetails = Loadable({
  loader: () => import(/* webpackChunkName: "ArticleDetails" */ '../components/Feature/ConsumerArticle/ArticleDetails'),
  loading: () => <div></div>,
  modules: ['Feature/ConsumerArticle/ArticleDetails'],
  });
const FeatureConsumerHeaderHeader = Loadable({
  loader: () => import(/* webpackChunkName: "Header" */ '../components/Feature/ConsumerHeader/Header'),
  loading: () => <div></div>,
  modules: ['Feature/ConsumerHeader/Header'],
  });
const FeatureConsumerNavigationHeaderSubNav = Loadable({
  loader: () => import(/* webpackChunkName: "HeaderSubNav" */ '../components/Feature/ConsumerNavigation/HeaderSubNav'),
  loading: () => <div></div>,
  modules: ['Feature/ConsumerNavigation/HeaderSubNav'],
  });
const FeatureCraftCraftDetails = Loadable({
  loader: () => import(/* webpackChunkName: "CraftDetails" */ '../components/Feature/Craft/CraftDetails'),
  loading: () => <div></div>,
  modules: ['Feature/Craft/CraftDetails'],
  });
const FeatureCraftCraftQuickLinksMenu = Loadable({
  loader: () => import(/* webpackChunkName: "CraftQuickLinksMenu" */ '../components/Feature/Craft/CraftQuickLinksMenu'),
  loading: () => <div></div>,
  modules: ['Feature/Craft/CraftQuickLinksMenu'],
  });
const FeatureFeaturedRetailerFeaturedRetailer = Loadable({
  loader: () => import(/* webpackChunkName: "FeaturedRetailer" */ '../components/Feature/FeaturedRetailer/FeaturedRetailer'),
  loading: () => <div></div>,
  modules: ['Feature/FeaturedRetailer/FeaturedRetailer'],
  });
const FeatureFormsContactUs = Loadable({
  loader: () => import(/* webpackChunkName: "ContactUs" */ '../components/Feature/Forms/ContactUs'),
  loading: () => <div></div>,
  modules: ['Feature/Forms/ContactUs'],
  });
const FeatureFormsContactUsInputFields = Loadable({
  loader: () => import(/* webpackChunkName: "ContactUsInputFields" */ '../components/Feature/Forms/ContactUsInputFields'),
  loading: () => <div></div>,
  modules: ['Feature/Forms/ContactUsInputFields'],
  });
const FeatureFormsNewsletter = Loadable({
  loader: () => import(/* webpackChunkName: "Newsletter" */ '../components/Feature/Forms/Newsletter'),
  loading: () => <div></div>,
  modules: ['Feature/Forms/Newsletter'],
  });
const FeatureGenericContentAdCampaign = Loadable({
  loader: () => import(/* webpackChunkName: "AdCampaign" */ '../components/Feature/GenericContent/AdCampaign'),
  loading: () => <div></div>,
  modules: ['Feature/GenericContent/AdCampaign'],
  });
const FeatureGenericContentConsumerFAQ = Loadable({
  loader: () => import(/* webpackChunkName: "ConsumerFAQ" */ '../components/Feature/GenericContent/ConsumerFAQ'),
  loading: () => <div></div>,
  modules: ['Feature/GenericContent/ConsumerFAQ'],
  });
const FeatureGenericContentConsumerFAQBlock = Loadable({
  loader: () => import(/* webpackChunkName: "ConsumerFAQBlock" */ '../components/Feature/GenericContent/ConsumerFAQBlock'),
  loading: () => <div></div>,
  modules: ['Feature/GenericContent/ConsumerFAQBlock'],
  });
const FeatureGenericContentGeneralNote = Loadable({
  loader: () => import(/* webpackChunkName: "GeneralNote" */ '../components/Feature/GenericContent/GeneralNote'),
  loading: () => <div></div>,
  modules: ['Feature/GenericContent/GeneralNote'],
  });
const FeatureGenericContentGeneralSection = Loadable({
  loader: () => import(/* webpackChunkName: "GeneralSection" */ '../components/Feature/GenericContent/GeneralSection'),
  loading: () => <div></div>,
  modules: ['Feature/GenericContent/GeneralSection'],
  });
const FeatureGenericContentGlobalFooter = Loadable({
  loader: () => import(/* webpackChunkName: "GlobalFooter" */ '../components/Feature/GenericContent/GlobalFooter'),
  loading: () => <div></div>,
  modules: ['Feature/GenericContent/GlobalFooter'],
  });
const FeatureGenericContentHero = Loadable({
  loader: () => import(/* webpackChunkName: "Hero" */ '../components/Feature/GenericContent/Hero'),
  loading: () => <div></div>,
  modules: ['Feature/GenericContent/Hero'],
  });
const FeatureGenericContentHeroDescription = Loadable({
  loader: () => import(/* webpackChunkName: "HeroDescription" */ '../components/Feature/GenericContent/HeroDescription'),
  loading: () => <div></div>,
  modules: ['Feature/GenericContent/HeroDescription'],
  });
const FeatureGenericContentHomepageHero = Loadable({
  loader: () => import(/* webpackChunkName: "HomepageHero" */ '../components/Feature/GenericContent/HomepageHero'),
  loading: () => <div></div>,
  modules: ['Feature/GenericContent/HomepageHero'],
  });
const FeatureGenericContentHomeQuickLinks = Loadable({
  loader: () => import(/* webpackChunkName: "HomeQuickLinks" */ '../components/Feature/GenericContent/HomeQuickLinks'),
  loading: () => <div></div>,
  modules: ['Feature/GenericContent/HomeQuickLinks'],
  });
const FeatureGenericContentImageGallery = Loadable({
  loader: () => import(/* webpackChunkName: "ImageGallery" */ '../components/Feature/GenericContent/ImageGallery'),
  loading: () => <div></div>,
  modules: ['Feature/GenericContent/ImageGallery'],
  });
const FeatureGenericContentImageTextBlock = Loadable({
  loader: () => import(/* webpackChunkName: "ImageTextBlock" */ '../components/Feature/GenericContent/ImageTextBlock'),
  loading: () => <div></div>,
  modules: ['Feature/GenericContent/ImageTextBlock'],
  });
const FeatureGenericContentObjectBlock = Loadable({
  loader: () => import(/* webpackChunkName: "ObjectBlock" */ '../components/Feature/GenericContent/ObjectBlock'),
  loading: () => <div></div>,
  modules: ['Feature/GenericContent/ObjectBlock'],
  });
const FeatureGenericContentQuickLinksMenu = Loadable({
  loader: () => import(/* webpackChunkName: "QuickLinksMenu" */ '../components/Feature/GenericContent/QuickLinksMenu'),
  loading: () => <div></div>,
  modules: ['Feature/GenericContent/QuickLinksMenu'],
  });
const FeatureGenericContentRichText = Loadable({
  loader: () => import(/* webpackChunkName: "RichText" */ '../components/Feature/GenericContent/RichText'),
  loading: () => <div></div>,
  modules: ['Feature/GenericContent/RichText'],
  });
const FeatureGenericContentServiceQuickLinksMenu = Loadable({
  loader: () => import(/* webpackChunkName: "ServiceQuickLinksMenu" */ '../components/Feature/GenericContent/ServiceQuickLinksMenu'),
  loading: () => <div></div>,
  modules: ['Feature/GenericContent/ServiceQuickLinksMenu'],
  });
const FeatureGenericContentTermsAndConditions = Loadable({
  loader: () => import(/* webpackChunkName: "TermsAndConditions" */ '../components/Feature/GenericContent/TermsAndConditions'),
  loading: () => <div></div>,
  modules: ['Feature/GenericContent/TermsAndConditions'],
  });
const FeatureGenericContentTextBlock = Loadable({
  loader: () => import(/* webpackChunkName: "TextBlock" */ '../components/Feature/GenericContent/TextBlock'),
  loading: () => <div></div>,
  modules: ['Feature/GenericContent/TextBlock'],
  });
const FeatureGenericContentTwoColumn7030 = Loadable({
  loader: () => import(/* webpackChunkName: "TwoColumn-70-30" */ '../components/Feature/GenericContent/TwoColumn-70-30'),
  loading: () => <div></div>,
  modules: ['Feature/GenericContent/TwoColumn-70-30'],
  });
const FeatureGettingHereGettingHereHeader = Loadable({
  loader: () => import(/* webpackChunkName: "GettingHereHeader" */ '../components/Feature/GettingHere/GettingHereHeader'),
  loading: () => <div></div>,
  modules: ['Feature/GettingHere/GettingHereHeader'],
  });
const FeatureHeaderGenericPageHeader = Loadable({
  loader: () => import(/* webpackChunkName: "GenericPageHeader" */ '../components/Feature/Header/GenericPageHeader'),
  loading: () => <div></div>,
  modules: ['Feature/Header/GenericPageHeader'],
  });
const FeatureHeaderHomePageHeader = Loadable({
  loader: () => import(/* webpackChunkName: "HomePageHeader" */ '../components/Feature/Header/HomePageHeader'),
  loading: () => <div></div>,
  modules: ['Feature/Header/HomePageHeader'],
  });
const FeatureHeaderPageHeader = Loadable({
  loader: () => import(/* webpackChunkName: "PageHeader" */ '../components/Feature/Header/PageHeader'),
  loading: () => <div></div>,
  modules: ['Feature/Header/PageHeader'],
  });
const FeatureHeaderWhatsOnListHeader = Loadable({
  loader: () => import(/* webpackChunkName: "WhatsOnListHeader" */ '../components/Feature/Header/WhatsOnListHeader'),
  loading: () => <div></div>,
  modules: ['Feature/Header/WhatsOnListHeader'],
  });
const FeatureLayoutInfoLayout = Loadable({
  loader: () => import(/* webpackChunkName: "InfoLayout" */ '../components/Feature/Layout/InfoLayout'),
  loading: () => <div></div>,
  modules: ['Feature/Layout/InfoLayout'],
  });
const FeatureLifestyleFeaturedLifestyle = Loadable({
  loader: () => import(/* webpackChunkName: "FeaturedLifestyle" */ '../components/Feature/Lifestyle/FeaturedLifestyle'),
  loading: () => <div></div>,
  modules: ['Feature/Lifestyle/FeaturedLifestyle'],
  });
const FeatureLifestyleLifestyleListingFilter = Loadable({
  loader: () => import(/* webpackChunkName: "LifestyleListingFilter" */ '../components/Feature/Lifestyle/LifestyleListingFilter'),
  loading: () => <div></div>,
  modules: ['Feature/Lifestyle/LifestyleListingFilter'],
  });
const FeatureMapsCentreMap = Loadable({
  loader: () => import(/* webpackChunkName: "CentreMap" */ '../components/Feature/Maps/CentreMap'),
  loading: () => <div></div>,
  modules: ['Feature/Maps/CentreMap'],
  });
const FeatureMapsGoogleMap = Loadable({
  loader: () => import(/* webpackChunkName: "GoogleMap" */ '../components/Feature/Maps/GoogleMap'),
  loading: () => <div></div>,
  modules: ['Feature/Maps/GoogleMap'],
  });
const FeatureMetricsPopularTimes = Loadable({
  loader: () => import(/* webpackChunkName: "PopularTimes" */ '../components/Feature/Metrics/PopularTimes'),
  loading: () => <div></div>,
  modules: ['Feature/Metrics/PopularTimes'],
  });
const FeatureOpeningHoursCentreOpeningHours = Loadable({
  loader: () => import(/* webpackChunkName: "CentreOpeningHours" */ '../components/Feature/OpeningHours/CentreOpeningHours'),
  loading: () => <div></div>,
  modules: ['Feature/OpeningHours/CentreOpeningHours'],
  });
const FeatureOpeningHoursMajorRetailersAndRestaurantsOpeningHours = Loadable({
  loader: () => import(/* webpackChunkName: "MajorRetailersAndRestaurantsOpeningHours" */ '../components/Feature/OpeningHours/MajorRetailersAndRestaurantsOpeningHours'),
  loading: () => <div></div>,
  modules: ['Feature/OpeningHours/MajorRetailersAndRestaurantsOpeningHours'],
  });
const FeatureOpeningHoursOpeningHoursHeader = Loadable({
  loader: () => import(/* webpackChunkName: "OpeningHoursHeader" */ '../components/Feature/OpeningHours/OpeningHoursHeader'),
  loading: () => <div></div>,
  modules: ['Feature/OpeningHours/OpeningHoursHeader'],
  });
const FeatureParkingCarPark = Loadable({
  loader: () => import(/* webpackChunkName: "CarPark" */ '../components/Feature/Parking/CarPark'),
  loading: () => <div></div>,
  modules: ['Feature/Parking/CarPark'],
  });
const FeatureParkingParkingInformation = Loadable({
  loader: () => import(/* webpackChunkName: "ParkingInformation" */ '../components/Feature/Parking/ParkingInformation'),
  loading: () => <div></div>,
  modules: ['Feature/Parking/ParkingInformation'],
  });
const FeatureParkingParkingRates = Loadable({
  loader: () => import(/* webpackChunkName: "ParkingRates" */ '../components/Feature/Parking/ParkingRates'),
  loading: () => <div></div>,
  modules: ['Feature/Parking/ParkingRates'],
  });
const FeatureParkingValetParking = Loadable({
  loader: () => import(/* webpackChunkName: "ValetParking" */ '../components/Feature/Parking/ValetParking'),
  loading: () => <div></div>,
  modules: ['Feature/Parking/ValetParking'],
  });
const FeaturePrecinctsCampaignFeaturedStoreList = Loadable({
  loader: () => import(/* webpackChunkName: "CampaignFeaturedStoreList" */ '../components/Feature/Precincts/CampaignFeaturedStoreList'),
  loading: () => <div></div>,
  modules: ['Feature/Precincts/CampaignFeaturedStoreList'],
  });
const FeaturePrecinctsFeaturedPrecinct = Loadable({
  loader: () => import(/* webpackChunkName: "FeaturedPrecinct" */ '../components/Feature/Precincts/FeaturedPrecinct'),
  loading: () => <div></div>,
  modules: ['Feature/Precincts/FeaturedPrecinct'],
  });
const FeaturePromotionsCampaignFeaturedWhatsOn = Loadable({
  loader: () => import(/* webpackChunkName: "CampaignFeaturedWhatsOn" */ '../components/Feature/Promotions/CampaignFeaturedWhatsOn'),
  loading: () => <div></div>,
  modules: ['Feature/Promotions/CampaignFeaturedWhatsOn'],
  });
const FeaturePromotionsCategoryHeader = Loadable({
  loader: () => import(/* webpackChunkName: "CategoryHeader" */ '../components/Feature/Promotions/CategoryHeader'),
  loading: () => <div></div>,
  modules: ['Feature/Promotions/CategoryHeader'],
  });
const FeaturePromotionsCategorySpotlight = Loadable({
  loader: () => import(/* webpackChunkName: "CategorySpotlight" */ '../components/Feature/Promotions/CategorySpotlight'),
  loading: () => <div></div>,
  modules: ['Feature/Promotions/CategorySpotlight'],
  });
const FeaturePromotionsCategoryWhatsOn = Loadable({
  loader: () => import(/* webpackChunkName: "CategoryWhatsOn" */ '../components/Feature/Promotions/CategoryWhatsOn'),
  loading: () => <div></div>,
  modules: ['Feature/Promotions/CategoryWhatsOn'],
  });
const FeaturePromotionsFeaturedPromotions = Loadable({
  loader: () => import(/* webpackChunkName: "FeaturedPromotions" */ '../components/Feature/Promotions/FeaturedPromotions'),
  loading: () => <div></div>,
  modules: ['Feature/Promotions/FeaturedPromotions'],
  });
const FeaturePromotionsHeroPromotion = Loadable({
  loader: () => import(/* webpackChunkName: "HeroPromotion" */ '../components/Feature/Promotions/HeroPromotion'),
  loading: () => <div></div>,
  modules: ['Feature/Promotions/HeroPromotion'],
  });
const FeaturePromotionsPromotionDetails = Loadable({
  loader: () => import(/* webpackChunkName: "PromotionDetails" */ '../components/Feature/Promotions/PromotionDetails'),
  loading: () => <div></div>,
  modules: ['Feature/Promotions/PromotionDetails'],
  });
const FeaturePromotionsPromotionSchedules = Loadable({
  loader: () => import(/* webpackChunkName: "PromotionSchedules" */ '../components/Feature/Promotions/PromotionSchedules'),
  loading: () => <div></div>,
  modules: ['Feature/Promotions/PromotionSchedules'],
  });
const FeaturePromotionsSimilarPromotions = Loadable({
  loader: () => import(/* webpackChunkName: "SimilarPromotions" */ '../components/Feature/Promotions/SimilarPromotions'),
  loading: () => <div></div>,
  modules: ['Feature/Promotions/SimilarPromotions'],
  });
const FeaturePromotionsStorefrontWhatsOn = Loadable({
  loader: () => import(/* webpackChunkName: "StorefrontWhatsOn" */ '../components/Feature/Promotions/StorefrontWhatsOn'),
  loading: () => <div></div>,
  modules: ['Feature/Promotions/StorefrontWhatsOn'],
  });
const FeaturePromotionsWhatsOn = Loadable({
  loader: () => import(/* webpackChunkName: "WhatsOn" */ '../components/Feature/Promotions/WhatsOn'),
  loading: () => <div></div>,
  modules: ['Feature/Promotions/WhatsOn'],
  });
const FeaturePromotionsWhatsOnList = Loadable({
  loader: () => import(/* webpackChunkName: "WhatsOnList" */ '../components/Feature/Promotions/WhatsOnList'),
  loading: () => <div></div>,
  modules: ['Feature/Promotions/WhatsOnList'],
  });
const FeatureRecipeFeaturedRecipe = Loadable({
  loader: () => import(/* webpackChunkName: "FeaturedRecipe" */ '../components/Feature/Recipe/FeaturedRecipe'),
  loading: () => <div></div>,
  modules: ['Feature/Recipe/FeaturedRecipe'],
  });
const FeatureRecipeRecipeDetails = Loadable({
  loader: () => import(/* webpackChunkName: "RecipeDetails" */ '../components/Feature/Recipe/RecipeDetails'),
  loading: () => <div></div>,
  modules: ['Feature/Recipe/RecipeDetails'],
  });
const FeatureRecipeRecipeListingFilter = Loadable({
  loader: () => import(/* webpackChunkName: "RecipeListingFilter" */ '../components/Feature/Recipe/RecipeListingFilter'),
  loading: () => <div></div>,
  modules: ['Feature/Recipe/RecipeListingFilter'],
  });
const FeatureRecipeRecipeQuickLinksMenu = Loadable({
  loader: () => import(/* webpackChunkName: "RecipeQuickLinksMenu" */ '../components/Feature/Recipe/RecipeQuickLinksMenu'),
  loading: () => <div></div>,
  modules: ['Feature/Recipe/RecipeQuickLinksMenu'],
  });
const FeatureSearchCategoryResults = Loadable({
  loader: () => import(/* webpackChunkName: "CategoryResults" */ '../components/Feature/Search/CategoryResults'),
  loading: () => <div></div>,
  modules: ['Feature/Search/CategoryResults'],
  });
const FeatureSearchSearchBar = Loadable({
  loader: () => import(/* webpackChunkName: "SearchBar" */ '../components/Feature/Search/SearchBar'),
  loading: () => <div></div>,
  modules: ['Feature/Search/SearchBar'],
  });
const FeatureSearchSearchModal = Loadable({
  loader: () => import(/* webpackChunkName: "SearchModal" */ '../components/Feature/Search/SearchModal'),
  loading: () => <div></div>,
  modules: ['Feature/Search/SearchModal'],
  });
const FeatureSearchSiteSearch = Loadable({
  loader: () => import(/* webpackChunkName: "SiteSearch" */ '../components/Feature/Search/SiteSearch'),
  loading: () => <div></div>,
  modules: ['Feature/Search/SiteSearch'],
  });
const FeatureSearchStoreResults = Loadable({
  loader: () => import(/* webpackChunkName: "StoreResults" */ '../components/Feature/Search/StoreResults'),
  loading: () => <div></div>,
  modules: ['Feature/Search/StoreResults'],
  });
const FeatureSearchWhatsOnResults = Loadable({
  loader: () => import(/* webpackChunkName: "WhatsOnResults" */ '../components/Feature/Search/WhatsOnResults'),
  loading: () => <div></div>,
  modules: ['Feature/Search/WhatsOnResults'],
  });
const FeatureSocialInstagramGallery = Loadable({
  loader: () => import(/* webpackChunkName: "InstagramGallery" */ '../components/Feature/Social/InstagramGallery'),
  loading: () => <div></div>,
  modules: ['Feature/Social/InstagramGallery'],
  });
const FeatureStoreDirectoryDirectoryHeader = Loadable({
  loader: () => import(/* webpackChunkName: "DirectoryHeader" */ '../components/Feature/StoreDirectory/DirectoryHeader'),
  loading: () => <div></div>,
  modules: ['Feature/StoreDirectory/DirectoryHeader'],
  });
const FeatureStoreDirectoryDirectoryList = Loadable({
  loader: () => import(/* webpackChunkName: "DirectoryList" */ '../components/Feature/StoreDirectory/DirectoryList'),
  loading: () => <div></div>,
  modules: ['Feature/StoreDirectory/DirectoryList'],
  });
const FeatureStoreDirectoryDirectorySearch = Loadable({
  loader: () => import(/* webpackChunkName: "DirectorySearch" */ '../components/Feature/StoreDirectory/DirectorySearch'),
  loading: () => <div></div>,
  modules: ['Feature/StoreDirectory/DirectorySearch'],
  });
const FeatureStoreDirectoryMiniStoreDirectory = Loadable({
  loader: () => import(/* webpackChunkName: "MiniStoreDirectory" */ '../components/Feature/StoreDirectory/MiniStoreDirectory'),
  loading: () => <div></div>,
  modules: ['Feature/StoreDirectory/MiniStoreDirectory'],
  });
const FeatureStorefrontCategoryDiscoverStores = Loadable({
  loader: () => import(/* webpackChunkName: "CategoryDiscoverStores" */ '../components/Feature/Storefront/CategoryDiscoverStores'),
  loading: () => <div></div>,
  modules: ['Feature/Storefront/CategoryDiscoverStores'],
  });
const FeatureStorefrontRecommendation = Loadable({
  loader: () => import(/* webpackChunkName: "Recommendation" */ '../components/Feature/Storefront/Recommendation'),
  loading: () => <div></div>,
  modules: ['Feature/Storefront/Recommendation'],
  });
const FeatureStorefrontRetailerDetails = Loadable({
  loader: () => import(/* webpackChunkName: "RetailerDetails" */ '../components/Feature/Storefront/RetailerDetails'),
  loading: () => <div></div>,
  modules: ['Feature/Storefront/RetailerDetails'],
  });
const FeatureStorefrontRetailerImageGallery = Loadable({
  loader: () => import(/* webpackChunkName: "RetailerImageGallery" */ '../components/Feature/Storefront/RetailerImageGallery'),
  loading: () => <div></div>,
  modules: ['Feature/Storefront/RetailerImageGallery'],
  });
const FeatureSubscribeSignUp = Loadable({
  loader: () => import(/* webpackChunkName: "SignUp" */ '../components/Feature/Subscribe/SignUp'),
  loading: () => <div></div>,
  modules: ['Feature/Subscribe/SignUp'],
  });
const FeatureSubscribeSubscribe = Loadable({
  loader: () => import(/* webpackChunkName: "Subscribe" */ '../components/Feature/Subscribe/Subscribe'),
  loading: () => <div></div>,
  modules: ['Feature/Subscribe/Subscribe'],
  });
const FeatureSubscribeUnsubscribe = Loadable({
  loader: () => import(/* webpackChunkName: "Unsubscribe" */ '../components/Feature/Subscribe/Unsubscribe'),
  loading: () => <div></div>,
  modules: ['Feature/Subscribe/Unsubscribe'],
  });
const FeatureSubscribeUpdatePreferences = Loadable({
  loader: () => import(/* webpackChunkName: "UpdatePreferences" */ '../components/Feature/Subscribe/UpdatePreferences'),
  loading: () => <div></div>,
  modules: ['Feature/Subscribe/UpdatePreferences'],
  });
const FoundationFormsForm = Loadable({
  loader: () => import(/* webpackChunkName: "Form" */ '../components/Foundation/Forms/Form'),
  loading: () => <div></div>,
  modules: ['Foundation/Forms/Form'],
  });
const FoundationLayoutTwoColumn7030 = Loadable({
  loader: () => import(/* webpackChunkName: "TwoColumn-70-30" */ '../components/Foundation/Layout/TwoColumn-70-30'),
  loading: () => <div></div>,
  modules: ['Foundation/Layout/TwoColumn-70-30'],
  });

const components = new Map();
components.set('Common-Animations-RiseAndFade', CommonAnimationsRiseAndFade);
components.set('Common-Animations-SearchSkeleton', CommonAnimationsSearchSkeleton);
components.set('Common-Helper-GetAncestorElement', CommonHelperGetAncestorElement);
components.set('Common-Tiles-FeaturedLifestyle', CommonTilesFeaturedLifestyle);
components.set('Common-Tiles-FeaturedRecipe', CommonTilesFeaturedRecipe);
components.set('Feature-Blog-BlogDetails', FeatureBlogBlogDetails);
components.set('Feature-Campaign-CampaignDetails', FeatureCampaignCampaignDetails);
components.set('Feature-Campaign-CampaignTitle', FeatureCampaignCampaignTitle);
components.set('Feature-Category-RelatedSubcategory', FeatureCategoryRelatedSubcategory);
components.set('Feature-CentreServices-CentreServicesHighlight', FeatureCentreServicesCentreServicesHighlight);
components.set('Feature-CentreServices-CentreServicesListInlineImage', FeatureCentreServicesCentreServicesListInlineImage);
components.set('Feature-CentreServices-CentreServicesListLeftImage', FeatureCentreServicesCentreServicesListLeftImage);
components.set('Feature-CentreServices-FeaturedServicesHighlight', FeatureCentreServicesFeaturedServicesHighlight);
components.set('Feature-Cinema-NowShowing', FeatureCinemaNowShowing);
components.set('Feature-ConsumerArticle-ArticleDetails', FeatureConsumerArticleArticleDetails);
components.set('Feature-ConsumerHeader-Header', FeatureConsumerHeaderHeader);
components.set('Feature-ConsumerNavigation-HeaderSubNav', FeatureConsumerNavigationHeaderSubNav);
components.set('Feature-Craft-CraftDetails', FeatureCraftCraftDetails);
components.set('Feature-Craft-CraftQuickLinksMenu', FeatureCraftCraftQuickLinksMenu);
components.set('Feature-FeaturedRetailer-FeaturedRetailer', FeatureFeaturedRetailerFeaturedRetailer);
components.set('Feature-Forms-ContactUs', FeatureFormsContactUs);
components.set('Feature-Forms-ContactUsInputFields', FeatureFormsContactUsInputFields);
components.set('Feature-Forms-Newsletter', FeatureFormsNewsletter);
components.set('Feature-GenericContent-AdCampaign', FeatureGenericContentAdCampaign);
components.set('Feature-GenericContent-ConsumerFAQ', FeatureGenericContentConsumerFAQ);
components.set('Feature-GenericContent-ConsumerFAQBlock', FeatureGenericContentConsumerFAQBlock);
components.set('Feature-GenericContent-GeneralNote', FeatureGenericContentGeneralNote);
components.set('Feature-GenericContent-GeneralSection', FeatureGenericContentGeneralSection);
components.set('Feature-GenericContent-GlobalFooter', FeatureGenericContentGlobalFooter);
components.set('Feature-GenericContent-Hero', FeatureGenericContentHero);
components.set('Feature-GenericContent-HeroDescription', FeatureGenericContentHeroDescription);
components.set('Feature-GenericContent-HomepageHero', FeatureGenericContentHomepageHero);
components.set('Feature-GenericContent-HomeQuickLinks', FeatureGenericContentHomeQuickLinks);
components.set('Feature-GenericContent-ImageGallery', FeatureGenericContentImageGallery);
components.set('Feature-GenericContent-ImageTextBlock', FeatureGenericContentImageTextBlock);
components.set('Feature-GenericContent-ObjectBlock', FeatureGenericContentObjectBlock);
components.set('Feature-GenericContent-QuickLinksMenu', FeatureGenericContentQuickLinksMenu);
components.set('Feature-GenericContent-RichText', FeatureGenericContentRichText);
components.set('Feature-GenericContent-ServiceQuickLinksMenu', FeatureGenericContentServiceQuickLinksMenu);
components.set('Feature-GenericContent-TermsAndConditions', FeatureGenericContentTermsAndConditions);
components.set('Feature-GenericContent-TextBlock', FeatureGenericContentTextBlock);
components.set('Feature-GenericContent-TwoColumn-70-30', FeatureGenericContentTwoColumn7030);
components.set('Feature-GettingHere-GettingHereHeader', FeatureGettingHereGettingHereHeader);
components.set('Feature-Header-GenericPageHeader', FeatureHeaderGenericPageHeader);
components.set('Feature-Header-HomePageHeader', FeatureHeaderHomePageHeader);
components.set('Feature-Header-PageHeader', FeatureHeaderPageHeader);
components.set('Feature-Header-WhatsOnListHeader', FeatureHeaderWhatsOnListHeader);
components.set('Feature-Layout-InfoLayout', FeatureLayoutInfoLayout);
components.set('Feature-Lifestyle-FeaturedLifestyle', FeatureLifestyleFeaturedLifestyle);
components.set('Feature-Lifestyle-LifestyleListingFilter', FeatureLifestyleLifestyleListingFilter);
components.set('Feature-Maps-CentreMap', FeatureMapsCentreMap);
components.set('Feature-Maps-GoogleMap', FeatureMapsGoogleMap);
components.set('Feature-Metrics-PopularTimes', FeatureMetricsPopularTimes);
components.set('Feature-OpeningHours-CentreOpeningHours', FeatureOpeningHoursCentreOpeningHours);
components.set('Feature-OpeningHours-MajorRetailersAndRestaurantsOpeningHours', FeatureOpeningHoursMajorRetailersAndRestaurantsOpeningHours);
components.set('Feature-OpeningHours-OpeningHoursHeader', FeatureOpeningHoursOpeningHoursHeader);
components.set('Feature-Parking-CarPark', FeatureParkingCarPark);
components.set('Feature-Parking-ParkingInformation', FeatureParkingParkingInformation);
components.set('Feature-Parking-ParkingRates', FeatureParkingParkingRates);
components.set('Feature-Parking-ValetParking', FeatureParkingValetParking);
components.set('Feature-Precincts-CampaignFeaturedStoreList', FeaturePrecinctsCampaignFeaturedStoreList);
components.set('Feature-Precincts-FeaturedPrecinct', FeaturePrecinctsFeaturedPrecinct);
components.set('Feature-Promotions-CampaignFeaturedWhatsOn', FeaturePromotionsCampaignFeaturedWhatsOn);
components.set('Feature-Promotions-CategoryHeader', FeaturePromotionsCategoryHeader);
components.set('Feature-Promotions-CategorySpotlight', FeaturePromotionsCategorySpotlight);
components.set('Feature-Promotions-CategoryWhatsOn', FeaturePromotionsCategoryWhatsOn);
components.set('Feature-Promotions-FeaturedPromotions', FeaturePromotionsFeaturedPromotions);
components.set('Feature-Promotions-HeroPromotion', FeaturePromotionsHeroPromotion);
components.set('Feature-Promotions-PromotionDetails', FeaturePromotionsPromotionDetails);
components.set('Feature-Promotions-PromotionSchedules', FeaturePromotionsPromotionSchedules);
components.set('Feature-Promotions-SimilarPromotions', FeaturePromotionsSimilarPromotions);
components.set('Feature-Promotions-StorefrontWhatsOn', FeaturePromotionsStorefrontWhatsOn);
components.set('Feature-Promotions-WhatsOn', FeaturePromotionsWhatsOn);
components.set('Feature-Promotions-WhatsOnList', FeaturePromotionsWhatsOnList);
components.set('Feature-Recipe-FeaturedRecipe', FeatureRecipeFeaturedRecipe);
components.set('Feature-Recipe-RecipeDetails', FeatureRecipeRecipeDetails);
components.set('Feature-Recipe-RecipeListingFilter', FeatureRecipeRecipeListingFilter);
components.set('Feature-Recipe-RecipeQuickLinksMenu', FeatureRecipeRecipeQuickLinksMenu);
components.set('Feature-Search-CategoryResults', FeatureSearchCategoryResults);
components.set('Feature-Search-SearchBar', FeatureSearchSearchBar);
components.set('Feature-Search-SearchModal', FeatureSearchSearchModal);
components.set('Feature-Search-SiteSearch', FeatureSearchSiteSearch);
components.set('Feature-Search-StoreResults', FeatureSearchStoreResults);
components.set('Feature-Search-WhatsOnResults', FeatureSearchWhatsOnResults);
components.set('Feature-Social-InstagramGallery', FeatureSocialInstagramGallery);
components.set('Feature-StoreDirectory-DirectoryHeader', FeatureStoreDirectoryDirectoryHeader);
components.set('Feature-StoreDirectory-DirectoryList', FeatureStoreDirectoryDirectoryList);
components.set('Feature-StoreDirectory-DirectorySearch', FeatureStoreDirectoryDirectorySearch);
components.set('Feature-StoreDirectory-MiniStoreDirectory', FeatureStoreDirectoryMiniStoreDirectory);
components.set('Feature-Storefront-CategoryDiscoverStores', FeatureStorefrontCategoryDiscoverStores);
components.set('Feature-Storefront-Recommendation', FeatureStorefrontRecommendation);
components.set('Feature-Storefront-RetailerDetails', FeatureStorefrontRetailerDetails);
components.set('Feature-Storefront-RetailerImageGallery', FeatureStorefrontRetailerImageGallery);
components.set('Feature-Subscribe-SignUp', FeatureSubscribeSignUp);
components.set('Feature-Subscribe-Subscribe', FeatureSubscribeSubscribe);
components.set('Feature-Subscribe-Unsubscribe', FeatureSubscribeUnsubscribe);
components.set('Feature-Subscribe-UpdatePreferences', FeatureSubscribeUpdatePreferences);
components.set('Foundation-Forms-Form', FoundationFormsForm);
components.set('Foundation-Layout-TwoColumn-70-30', FoundationLayoutTwoColumn7030);

export default function componentFactory(componentName) {
  return components.get(componentName);
};
